import { render, staticRenderFns } from "./PayrollChangeRequestStatusDisplay.vue?vue&type=template&id=319b7a30&"
import script from "./PayrollChangeRequestStatusDisplay.vue?vue&type=script&lang=ts&"
export * from "./PayrollChangeRequestStatusDisplay.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports